import produce from 'immer';
import {
  CHAT_COMPANY_SET_LOADING,
  CHAT_COMPANY_ADD_CHATS_SUCCESS,
  CHAT_COMPANY_ADD_NEW_CHAT_SUCCESS,
  CHAT_COMPANY_FETCH_CHATS_SUCCESS,
  CHAT_PROJECT_ADD_NEW_CHAT_SUCCESS,
  CHAT_PROJECT_ADD_CHATS_SUCCESS,
  CHAT_PROJECT_FETCH_CHATS_SUCCESS,
  CHAT_PROJECT_SET_LOADING,
  CHAT_CURRENT_MESSAGES_SET_LOADING,
  CHAT_CURRENT_MESSAGES_ADD_SUCCESS,
  CHAT_CURRENT_MESSAGES_FETCH_SUCCESS,
  CHAT_PROJECT_REPLACE_OR_ADD_CHAT_SUCCESS,
  CHAT_COMPANY_REPLACE_OR_ADD_CHAT_SUCCESS,
  CHAT_CURRENT_MESSAGES_NEW_SUCCESS,
  CHAT_ACTIVE_SET,
  CHAT_PROJECT_UPDATE_USER_READ_COUNT_SUCCESS,
  CHAT_COMPANY_UPDATE_USER_READ_COUNT_SUCCESS,
  CHAT_ACTIVE_UPDATE_USER_READ_COUNT,
} from './constants';
import { chatIdInArray, chatInArray } from '../../util/chat';

export function chatProjectLoadChats(state = { items: [], totalCount: 0 }, action) {
  switch (action.type) {
    case CHAT_PROJECT_FETCH_CHATS_SUCCESS:
      return {
        items: action.data.items,
        totalCount: action.data.totalCount,
      };
    case CHAT_PROJECT_ADD_CHATS_SUCCESS:
      const newItems = [...state.items];
      action.data.items.forEach((loadedItem) => {
        if (!chatInArray(loadedItem, state.items)) {
          newItems.push(loadedItem);
        }
      });
      return {
        items: newItems,
        totalCount: action.data.totalCount,
      };
    case CHAT_PROJECT_ADD_NEW_CHAT_SUCCESS:
      // Check if new chat is fetched already. race condition
      if (chatInArray(action.chat, state.items)) {
        return state;
      }

      return {
        items: [action.chat, ...state.items],
        totalCount: state.totalCount + 1,
      };
    case CHAT_PROJECT_REPLACE_OR_ADD_CHAT_SUCCESS:
      let totalCount = state.totalCount;
      // Check if chat is in the list
      if (!chatInArray(action.chat, state.items)) {
        totalCount++;
      }

      return {
        items: [action.chat, ...state.items.filter((ch) => ch._id !== action.chat._id)],
        totalCount: totalCount,
      };
    case CHAT_PROJECT_UPDATE_USER_READ_COUNT_SUCCESS:
      if (!chatIdInArray(action.chatUser.chatId, state.items)) {
        return state;
      }

      return produce(state, (draftState) => {
        for (let [index, chat] of draftState.items.entries()) {
          if (chat._id === action.chatUser.chatId) {
            draftState.items[index].chatUser = action.chatUser;
          }
        }
      });
    default:
      return state;
  }
}

export function chatProjectSetLoading(state = false, action) {
  switch (action.type) {
    case CHAT_PROJECT_SET_LOADING:
      return action.loading;
    default:
      return state;
  }
}

export function chatCompanyChats(state = { items: [], totalCount: 0 }, action) {
  switch (action.type) {
    case CHAT_COMPANY_FETCH_CHATS_SUCCESS:
      return {
        items: action.data.items,
        totalCount: action.data.totalCount,
      };
    case CHAT_COMPANY_ADD_CHATS_SUCCESS:
      const newItems = [...state.items];
      action.data.items.forEach((loadedItem) => {
        if (!chatInArray(loadedItem, state.items)) {
          newItems.push(loadedItem);
        }
      });
      return {
        items: newItems,
        totalCount: action.data.totalCount,
      };
    case CHAT_COMPANY_ADD_NEW_CHAT_SUCCESS:
      // Check if new chat is fetched already. race condition
      if (chatInArray(action.chat, state.items)) {
        return state;
      }

      return {
        items: [action.chat, ...state.items],
        totalCount: state.totalCount + 1,
      };
    case CHAT_COMPANY_REPLACE_OR_ADD_CHAT_SUCCESS:
      let totalCount = state.totalCount;
      // Check if chat is in the list
      if (!chatInArray(action.chat, state.items)) {
        totalCount++;
      }

      return {
        items: [action.chat, ...state.items.filter((ch) => ch._id !== action.chat._id)],
        totalCount: totalCount,
      };
    case CHAT_COMPANY_UPDATE_USER_READ_COUNT_SUCCESS:
      if (!chatIdInArray(action.chatUser.chatId, state.items)) {
        return state;
      }

      return produce(state, (draftState) => {
        for (let [index, chat] of draftState.items.entries()) {
          if (chat._id === action.chatUser.chatId) {
            draftState.items[index].chatUser = action.chatUser;
          }
        }
      });
    default:
      return state;
  }
}

export function chatCompanySetLoading(state = false, action) {
  switch (action.type) {
    case CHAT_COMPANY_SET_LOADING:
      return action.loading;
    default:
      return state;
  }
}

export function chatCurrentMessagesSetLoading(state = false, action) {
  switch (action.type) {
    case CHAT_CURRENT_MESSAGES_SET_LOADING:
      return action.loading;
    default:
      return state;
  }
}

export function chatCurrentMessagesChange(state = [], action) {
  switch (action.type) {
    case CHAT_CURRENT_MESSAGES_ADD_SUCCESS:
      return action.data;
    case CHAT_CURRENT_MESSAGES_FETCH_SUCCESS:
      return [...action.data, ...state];
    case CHAT_CURRENT_MESSAGES_NEW_SUCCESS:
      return [...state, ...action.data];
    default:
      return state;
  }
}

export function chatActive(state = null, action) {
  switch (action.type) {
    case CHAT_ACTIVE_SET:
      return action.chat;
    case CHAT_ACTIVE_UPDATE_USER_READ_COUNT:
      if (state && state._id === action.chatUser.chatId) {
        return produce(state, (draftState) => {
          draftState.chatUser = action.chatUser;
        });
      }

      return state;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/container/chat/reducers.js